// extracted by mini-css-extract-plugin
module.exports = {"description":"styles_description__2blvC","blockTexts":"styles_blockTexts__1BY8Q"};